<template lang="html">

 <header class="header" :min="min && !open" :open="open">

  <section class="top row-between">
    <div class="logos">
      <a href="https://www.dipujaen.es/" target="_blank"><img src="/static/img/logo-diputacion-verde.svg" alt="Diputación de Jaén"></a>
    </div>
    <div class="right row-end">
      <!-- <img v-if="!!$route.params.id" :src="`/static/img/logo-${$route.params.id}.svg`" class="big"> -->
      <a class="logo-jaen" href="https://www.jaenparaisointerior.es/" target="_blank"><img src="/static/img/logo-color.svg" alt="Jaén paraiso interior"></a>
      <template v-if="$route.name != 'proximamente'">
      <a class="rrss" href="https://www.facebook.com/turismoprovinciajaen" target="_blank"><i class="fa fa-facebook"></i>facebook</a>
      <a class="rrss" href="https://www.instagram.com/jaenturismo_/" target="_blank"><i class="fa fa-instagram"></i>instagram</a>
      <a class="rrss" href="https://twitter.com/jaenturismo" target="_blank"><i class="fa fa-twitter"></i>twitter</a>
      <a class="show-menu" @click="open=!open" :open="open">
        <span></span>
        <span></span>
        <span></span>
        <i>✕</i>
      </a>
    </template>

    </div>
  </section>


  <section class="menu column-center" :open="open">
    <nav class="menu-links column-center">
      <router-link to="/">Inicio</router-link>
      <a>Las experiencias</a>
      <router-link v-for="(categoria, key) in categorias.filter(e => e.featured == 1 && !e.mother_id)" :key="key" class="sub" :to="$t('enlaces.categoria')+'/'+categoria.slug">{{categoria.name}}</router-link>
      
      <router-link :to="$t('enlaces.como_inscribirte')">¿Cómo inscribirte?</router-link>
      <router-link to="/buscador">Buscador</router-link>
    </nav>

    <a :href="`tel:${$t('Teléfono información')}`" class="mas-info">{{$t('Más información')}}: {{$t('Teléfono información')}}</a>

  </section>

 </header>

</template>

<script lang="js">

import { mapGetters } from 'vuex';

  export default  {
    name: 'app-header',
    mounted(){
      this.checkMin();
      $(window).scroll(e => {
        this.checkMin();
      }); 
    },
    data(){
      return{
        min : true,
        open: false
      }
    },
    methods : {
      checkMin(){
        let top = $(window).scrollTop();
        this.min = (top > 400);
      },
      inscribir(){
        window.location.href = '/#como-inscribirte';
        
      },
    },
    computed: {
      ...mapGetters({
        categorias: 'getCategorias'
      })
    },
    watch :{
      '$route'(){
        this.open = false;
      }
    } 
}
</script>

<style scoped>
  .header {

  }
</style>



// WEBPACK FOOTER //
// src/components/parts/header.vue